/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import qmeter_logo from "../assets/images/qmeter_logo.svg";
import { useSelector } from "react-redux";
import { convertToRGBAString } from "../utils/helperFunctions";
import ButtonHolder from "./ButtonHolder";
import debounce from "lodash.debounce";
import LogoComponent from "./LogoComponent";
import { fontSize } from "utils/CONSTANTS";
import { GoldenRatio } from "./models/GolderRatio";
import QmeterSection from "./header/QmeterSection";
import LogoSection from "./header/LogoSection";

//@ts-ignore
const NavHeader = React.memo(({ properties }) => {
  const { currentPage, maxPage, pages, selectedLanguage } = useSelector(
    (state) => state
  );

  const [NavHeigth, setNavHeigth] = useState("");
  const [Rotate, setRotate] = useState(window.orientation);

  useEffect(() => {
    const { page_header } = properties;
    if (page_header) {
      const metas = document.getElementsByTagName("meta");
      for (let i = 0; i < metas.length; i++) {
        if (metas[i].getAttribute("name") === "theme-color") {
          document.head.removeChild(metas[i]);
        }
      }
      const themeColorMetaElement = document.createElement("meta");
      themeColorMetaElement.name = "theme-color";
      themeColorMetaElement.content = convertToRGBAString(page_header);
      document.head.appendChild(themeColorMetaElement);
      document.documentElement.style.setProperty(
        "--page-header-color",
        convertToRGBAString(page_header)
      );
    }

    window.addEventListener("orientationchange", () => {
      refresh();
    });
  }, []);

  useEffect(() => {
    let timeoutEnable = false;
    if (currentPage > maxPage) {
      const { timeout = {} } = pages.final_page_data || {};
      const { enable = false } = timeout;
      timeoutEnable = enable;
    } else {
      const { properties = null } = pages[currentPage] || {};
      if (properties) {
        const { enable = false } = properties.timeout || {};
        timeoutEnable = enable;
      }
    }

    if (timeoutEnable) {
      resetWidgetTimeout();
      document.onmousemove = resetWidgetTimeout;
      document.onkeypress = resetWidgetTimeout;
      document.ontouchstart = resetWidgetTimeout;
      document.onkeypress = resetWidgetTimeout;
    }

    return () => {
      resetWidgetTimeout.cancel();
    };
  }, [currentPage]);

  const resetWidgetTimeout = debounce(
    () => {
      console.log("reset");
      refresh();
    },
    currentPage <= maxPage
      ? pages[currentPage].properties.timeout?.time
      : pages.final_page_data.timeout?.time
  );

  const refresh = () => {
    document.location.reload();
  };

  const getPageHeaderHeiht = () => {
    //Godler Ratio
    const windowHeigt =
      window.innerWidth > 767
        ? window.innerHeight - (window.innerHeight * 6) / 100
        : window.innerHeight;
    const { B } = GoldenRatio({ height: windowHeigt });

    // if (currentPage == 0) {
    //   const languagePageLogo = (B * 14.6) / 100;
    //   setNavHeigth(languagePageLogo + "px");
    // } else if (pages[currentPage]?.properties.is_page_title) {
    //   setNavHeigth(B + "px");
    // } else {
    //   const isPageTitle = B - (B * 24) / 100;
    //   setNavHeigth(isPageTitle + "px");
    // }
    if (pages[currentPage]?.properties.is_page_title) {
      setNavHeigth(B + "px");
    } else {
      const isPageTitle = B - (B * 24) / 100;
      setNavHeigth(isPageTitle + "px");
    }
  };

  useEffect(() => {
    getPageHeaderHeiht();
  }, [currentPage, Rotate]);

  const navCalc = {
    // language: "100%",
    language: "100%",
    qmeter: "19.2%",
    qmeterPageTitle: "14.6%",
    company: "80.8%",
    companyPageTitle: "60.4%",
  };

  return (
    properties && (
      // <div
      //   // align="middle"
      //   // justify="space-between"
      //   // style={{ position: "sticky", top: 0, zIndex: 1 }}
      //   style={{ height: NavHeigth, display: "flex", flexDirection: "column" }}
      // >
      //   <div
      //     // xs={24}
      //     className="left-to-right-holder"
      //     style={{
      //       backgroundColor: convertToRGBAString(properties.page_header),
      //       // padding: "12px 16px",
      //       position: "sticky",
      //       // boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
      //       top: 0,
      //       zIndex: 100,
      //       height:
      //         currentPage === 0
      //           ? // ? navCalc["language"]
      //             // : pages[currentPage]?.properties.is_page_title
      //             // ? navCalc["qmeterPageTitle"]
      //             // : navCalc["qmeter"],
      //             navCalc["qmeter"]
      //           : pages[currentPage]?.properties.is_page_title
      //           ? navCalc["qmeterPageTitle"]
      //           : navCalc["qmeter"],
      //     }}
      //   >
      //     <div
      //       style={{
      //         position: "sticky",
      //         top: 0,
      //         zIndex: 100,
      //         // height: currentPage == 0 ? "19.2%" : "100%",
      //         height: "100%",
      //         // padding: "1vh",
      //         width: "66%",
      //         // boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
      //       }}
      //     >
      //       <img
      //         onClick={refresh}
      //         src={qmeter_logo}
      //         className="img-fluid logo"
      //         // style={{
      //         //   // height: 22,
      //         //   height: "100%",
      //         //   cursor: "pointer",
      //         //   verticalAlign: "unset",
      //         //   objectFit: "contain",
      //         //   padding: "1vh",
      //         //   paddingLeft: "20px",
      //         // }}
      //       />
      //     </div>
      //   </div>
      //   {currentPage != 0 && (
      //     <>
      //       <div
      //         // className="border"
      //         // xs={24}
      //         style={{
      //           // maxHeight: pages[currentPage]?.properties.is_page_title
      //           //   ? navCalc["companyPageTitle"]
      //           //   : navCalc["company"],
      //           maxHeight:
      //             currentPage == 0
      //               ? navCalc["company"]
      //               : pages[currentPage]?.properties.is_page_title
      //               ? navCalc["companyPageTitle"]
      //               : navCalc["company"],
      //           width: "100%",
      //           display: "flex",
      //           alignItems: "center",
      //           justifyContent: "center",
      //           flex: 1,
      //         }}
      //       >
      //         {/* <div
      //           style={{
      //             display: "flex",
      //             alignItems: "center",
      //             flexDirection: "column",
      //           }}
      //         > */}
      //         {/* <LogoComponent
      //           source={json.data.general_settings.logo_url}
      //           size={json.data.general_settings.logo_size || "M"}
      //         /> */}
      //         {/* </div> */}
      //         {/* <div
      //           style={{
      //             maxHeight: "85%",
      //             maxWidth: "61.4%",
      //           }}
      //         > */}
      //         <img
      //           src={json?.data?.general_settings?.logo_url}
      //           className="img-fluid"
      //           style={{
      //             width: "61.4%",
      //             height: "85%",
      //             objectFit: "contain",
      //           }}
      //         />
      //         {/* </div>
      //         {/* <div
      //           style={{
      //             height: "85%",
      //             width: "61.4%",
      //             backgroundImage: `url(${json?.data?.general_settings?.logo_url})`,
      //           }}
      //         ></div> */}
      //       </div>

      //       {pages[currentPage]?.properties.is_page_title && (
      //         <div
      //           // xs={24}
      //           style={{
      //             minHeight: "24%",
      //             display: "flex",
      //             alignItems: "center",
      //             justifyContent: "center",
      //             position: "relative",
      //             zIndex: 50,
      //           }}
      //           // className="border"
      //         >
      //           <div
      //             className="font-helvetica-neue-medium"
      //             style={{
      //               fontSize:
      //                 fontSize[pages[currentPage].properties.page_title_size],
      //               color: convertToRGBAString(
      //                 pages[currentPage].properties.page_title_text_color
      //               ),
      //               backgroundColor: convertToRGBAString(
      //                 pages[currentPage].properties.page_title_bg_color
      //               ),
      //               borderRadius: 8,
      //               padding: "1vh",
      //               maxWidth: "85.4%",
      //               textAlign: "center",
      //               lineClamp: 2,
      //               textOverflow: "ellipsis",
      //               overflow: "hidden",
      //               WebkitLineClamp: 2,
      //               WebkitBoxOrient: "vertical",
      //               display: "-webkit-box",
      //             }}
      //           >
      //             {/* {pages[currentPage].properties.page_title[selectedLanguage]} */}
      //             Please share your experience with us to help us on
      //             improvements
      //           </div>
      //         </div>
      //       )}
      //     </>
      //   )}
      // </div>
      <div
        style={{ height: NavHeigth, display: "flex", flexDirection: "column" }}
      >
        <QmeterSection
          properties={properties}
          height={
            pages[currentPage]?.properties.is_page_title
              ? navCalc["qmeterPageTitle"]
              : navCalc["qmeter"]
          }
        />
        {currentPage != 0 && (
          <>
            <LogoSection
              height={
                pages[currentPage]?.properties.is_page_title
                  ? navCalc["companyPageTitle"]
                  : navCalc["company"]
              }
            />

            {pages[currentPage]?.properties.is_page_title && (
              <div
                // xs={24}
                style={{
                  minHeight: "24%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  zIndex: 50,
                }}
                // className="border"
              >
                <div
                  className="font-helvetica-neue-medium"
                  style={{
                    fontSize:
                      fontSize[pages[currentPage].properties.page_title_size],
                    color: convertToRGBAString(
                      pages[currentPage].properties.page_title_text_color
                    ),
                    backgroundColor: convertToRGBAString(
                      pages[currentPage].properties.page_title_bg_color
                    ),
                    borderRadius: 8,
                    padding: "1vh",
                    maxWidth: "85.4%",
                  }}
                >
                  <p className="component_title">
                    {pages[currentPage].properties.page_title[selectedLanguage]}
                  </p>
                  {/* Please share your experience with us to help us on
                  improvements */}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    )
  );
});

export default NavHeader;
